import { checkRoutePassage, isRequestSuccess } from './lingdongApi'

export async function confirmRoutePassage(component, input, isCurrent) {
  const h = component.$createElement
  let message
  try {
    const response = await checkRoutePassage(input)
    if (!isCurrent()) return false
    if (!isRequestSuccess(response)) throw { msg: response.msg || '校验服务暂不可用', code: response.code }
    const items = response.data && response.data.items
    if (!Array.isArray(items) || !items.length || items.some(item => !['MATCHED', 'MISSED', 'UNKNOWN'].includes(item.status))) {
      throw new Error('校验结果不完整')
    }
    const attention = items.filter(item => item.status !== 'MATCHED')
    if (!attention.length) return true
    const matched = items.filter(item => item.status === 'MATCHED').length
    const missed = items.filter(item => item.status === 'MISSED').length
    const unknown = items.filter(item => item.status === 'UNKNOWN').length
    message = h('div', [
      h('p', `已经过 ${matched} 项，未经过 ${missed} 项，无法判断 ${unknown} 项。请确认以下对象后再保存：`),
      h('ul', { style: { maxHeight: '280px', overflowY: 'auto', paddingLeft: '20px' } }, attention.map(item => h('li', [
        `${item.targetType === 'FENCE' ? '围栏' : '节点'}：${item.name || (item.targetType === 'FENCE' && item.code) || '未命名'}${item.targetType === 'FENCE' && item.name && item.code ? `（${item.code}）` : ''}；${item.status === 'MISSED' ? '未经过' : '无法判断'}：${item.reason || '请检查坐标和区域配置'}`
      ])))
    ])
  } catch (error) {
    if (!isCurrent()) return false
    const response = error.response
    const codes = [error.code, response && response.status, response && response.data && response.data.code].map(Number)
    if (codes.includes(401) || codes.includes(403)) throw error
    message = h('div', [h('p', '本次路线经过情况无法校验，仍可选择保存。'), h('p', error.msg || error.message || '校验服务暂不可用')])
  }
  if (!isCurrent()) return false
  try {
    await component.$confirm(message, '路线经过校验提醒', {
      type: 'warning', confirmButtonText: '仍然保存', cancelButtonText: '返回调整', closeOnClickModal: false
    })
    return isCurrent()
  } catch (error) {
    if (error === 'cancel' || error === 'close') return false
    throw error
  }
}
